import { FeatureTypes } from "entity-app/constants";
import { TSaveColumnState } from ".";

export type MasterColumnConfigRow = {
  feature_type_id: number;
  column_config: TSaveColumnState;
};

export const hasUsableColumnConfig = (
  config?: TSaveColumnState | null
): boolean => (config?.columnList?.length ?? 0) > 0;

export function resolveMasterColumnConfig(
  rows: MasterColumnConfigRow[] | undefined,
  featureTypeId: FeatureTypes
): TSaveColumnState | null {
  const match = rows?.find(
    (row) => Number(row.feature_type_id) === Number(featureTypeId)
  );
  return hasUsableColumnConfig(match?.column_config)
    ? match!.column_config
    : null;
}

export function resolveEffectiveColumnConfig(
  userConfig: TSaveColumnState | null | undefined,
  masterRows: MasterColumnConfigRow[] | undefined,
  featureTypeId: FeatureTypes
): TSaveColumnState | null {
  if (hasUsableColumnConfig(userConfig)) {
    return userConfig!;
  }

  const masterConfig = resolveMasterColumnConfig(masterRows, featureTypeId);
  if (masterConfig) {
    return masterConfig;
  }

  return null;
}
